'use client';

import { AccountPopover, type AccountPopoverVariant } from '../shared';
import { Details, Drawer, Links } from './components';

import './authenticated.scss';

type AuthenticatedProps = {
    variant: AccountPopoverVariant;
};

export function Authenticated({ variant }: AuthenticatedProps) {
    function renderContent({ close }: { close: () => void }) {
        return (
            <div className="account-authenticated">
                <Details onAction={close} />
                <Links onAction={close} />
            </div>
        );
    }

    if (variant === 'desktop') {
        return (
            <AccountPopover accountHref="/account" variant="desktop">
                {renderContent}
            </AccountPopover>
        );
    }

    return <Drawer>{renderContent}</Drawer>;
}
